import React from 'react';
import NoUiSlider from '@ro-forks/NoUiSlider';

import { RadarSlider } from './RoSlider.styles';

const RoSlider = props => (
  <RadarSlider>
    <NoUiSlider {...props} />
  </RadarSlider>
);

export default RoSlider;
